import { Component, Input } from "@angular/core";
import { clientConfig } from "../../shared/constant/app.constant";

@Component({
  selector: "app-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.scss"],
})
export class MErrorComponent {
  @Input() icon = "fa-exclamation-triangle";
  // @Input() message = "Something went wrong!";
  // @Input() errortitle = "Error";
  @Input() error = {
    title: "",
    message: "Something went wrong!",
  };

  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
  };
}
